export const NO_WELCOME_DIALOG = 'NO_WELCOME_DIALOG';
export const WELCOME_DIALOG = 'WelcomeDialog';
